import React from "react";
import { makeStyles } from "tss-react/mui";

import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";
import Box from "@mui/material/Box";

const useStyles = makeStyles()((theme) => ({
  tags: {
    width: "100%",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-track": {
      borderRadius: "10px",
    },
  },
  tag: {
    fontSize: "14px",
    fontStyle: "inherit",
    height: "auto",
    padding: "4px",
  },
}));

const MultipleChipInput = (props) => {
  const {
    placeholder,
    error = false,
    errorText = "",
    helperText = "",
    handleOnChange = () => {},
    handleonInputChange = () => {},
    onDelete = () => {},
    handleKeyPress = () => {},
    handlePaste = () => {},
    maxHeight = "150px",
  } = props;

  const { classes } = useStyles();

  return (
    <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
      <Autocomplete
        {...props}
        multiple
        freeSolo
        options={[]}
        onChange={handleOnChange}
        onInputChange={handleonInputChange}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder={placeholder}
            onKeyDown={handleKeyPress}
            onPaste={handlePaste}
            error={error}
            helperText={error ? errorText || "" : helperText || ""}
          />
        )}
        renderTags={(value, getTagProps) => (
          <Box className={classes.tags} sx={{ maxHeight }}>
            {value.map((option, index) => (
              <Chip
                classes={{ root: classes.tag }}
                key={option}
                label={<Box sx={{ whiteSpace: "normal", wordBreak: "break-word", maxWidth: "100%" }}>{option}</Box>}
                {...getTagProps({ index })}
                onDelete={() => onDelete(option)}
              />
            ))}
          </Box>
        )}
      />
    </div>
  );
};

export default MultipleChipInput;
